import { render, staticRenderFns } from "./CDragScroll.vue?vue&type=template&id=7c2fdd47&scoped=true&"
import script from "./CDragScroll.vue?vue&type=script&lang=ts&"
export * from "./CDragScroll.vue?vue&type=script&lang=ts&"
import style0 from "./CDragScroll.vue?vue&type=style&index=0&id=7c2fdd47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2fdd47",
  null
  
)

export default component.exports